export default __webpack_public_path__ + "static/MineralSwim_BagSingle_10kg-ed0c38f05f2d8feb8aa5ab4bf47da28d.png";